/**
 * Safely check if a JWT access token is expired or about to expire.
 * @param token Raw JWT string
 * @param offsetSeconds Buffer in seconds (defaults to 10s before actual exp time)
 */
export function isJwtExpired(token: string | null | undefined, offsetSeconds = 10): boolean {
  if (!token?.trim()) return true;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return true;
    
    // Decode base64url payload
    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
    const payload = JSON.parse(jsonPayload);

    if (typeof payload.exp !== 'number') return false;
    const nowInSeconds = Math.floor(Date.now() / 1000);
    return payload.exp <= nowInSeconds + offsetSeconds;
  } catch {
    return true;
  }
}
